import React from "react";

const Join = () => {
  return (
    <>
      {/* <div className="px-4 sm:px-10 my-16">
        <div className="max-w-7xl w-full mx-auto px-6">
          <div className="grid md:grid-cols-2 items-center gap-10">
            <div className="w-full h-full">
              <img
                src="./edu.gif"
                alt="Premium Benefits"
                className="w-full h-[400px] object-cover"
              />
            </div>
            <div>
              <h2 className="md:text-4xl text-3xl font-semibold mb-6 ">
                {" "}
                Take Your IT Skills to the Next Level
              </h2>
              <p className="text-justify">
                {" "}
                IT skills are in high demand and can help you get a better job
                or start your own business. We offer a variety of IT courses to
                help you learn the skills you need to succeed. Get started
                today!
              </p>
              <div className="mt-8">
                <div className="flex items-center">
                  <a
                    href="#"
                    className="rounded-md bg-gray-800 px-3.5 py-2.5 text-sm font-semibold text-gray-100 shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                  >
                    Join Now
                  </a>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="my-8 relative font-sans before:absolute before:w-full before:h-full before:inset-0 before:bg-black/50 before:z-10">
        <img
          src="https://readymadeui.com/cardImg.webp"
          alt="Transform Your Career with Brain box Study"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="min-h-[380px] relative z-50 h-full max-w-6xl mx-auto flex flex-col justify-center items-center text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-2">
          Ready to Transform Your Career?
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-gray-200 leading-relaxed max-w-2xl">
          Join thousands of learners who have upgraded their skills and achieved their career dreams with BrainboxStudy. With our expert-led courses and flexible learning options, your success is just a click away.
          </p>
          <a href="/contact"
            
            className="px-4 py-2 sm:px-6 sm:py-3 mt-6  rounded-full text-white text-sm sm:text-base tracking-wide font-semibold outline-none bg-orange-600 hover:bg-orange-700 border-2 border-orange-600 transition-all duration-300"
          >
          Start Learning Today!
          </a>
        </div>
      </div>
    </>
  );
};

export default Join;
